'use client'

import { useEffect, useState } from 'react'

import { useUserAccount } from '../providers/UserAccountProvider'

type PartialWalletConnectProvider = {
  session: { peer: { metadata: { name: string } } }
}

const SAFE_WALLET_CONNECT_NAME = 'Safe{Wallet}'

// Resolves the WalletConnect peer metadata name (the app the user actually
// connected with — e.g. "Rabby", "Rainbow", "Safe{Wallet}") when the active
// connector is WalletConnect, otherwise returns undefined.
export function useWalletConnectMetadata() {
  const [walletName, setWalletName] = useState<string | undefined>(undefined)
  const { connector } = useUserAccount()

  useEffect(() => {
    let isActive = true

    if (!connector?.getProvider || connector.id !== 'walletConnect') {
      setWalletName(undefined)
      return
    }

    connector.getProvider().then(
      provider => {
        const walletConnectProvider = provider as PartialWalletConnectProvider
        try {
          if (isActive) setWalletName(walletConnectProvider.session.peer.metadata.name)
        } catch {
          // Ignore errors in metadata
        }
      },
      () => {
        if (isActive) setWalletName(undefined)
      }
    )

    return () => {
      isActive = false
    }
  }, [connector])

  const isSafeAccountViaWalletConnect = walletName === SAFE_WALLET_CONNECT_NAME

  return { isSafeAccountViaWalletConnect, walletConnectPeerName: walletName }
}
